"use strict";
/*!
 * Copyright 2018 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GrpcError =
/*#__PURE__*/
function (_Error) {
  _inherits(GrpcError, _Error);

  function GrpcError() {
    _classCallCheck(this, GrpcError);

    return _possibleConstructorReturn(this, _getPrototypeOf(GrpcError).apply(this, arguments));
  }

  return GrpcError;
}(_wrapNativeSuper(Error));

exports.GrpcError = GrpcError;